module.exports = __webpack_public_path__ + "img/explore.8ebe5cea.jpg";